"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9099],{

/***/ 66735:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

exports.Z = _default;

/***/ }),

/***/ 85984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

exports.Z = _default;

/***/ }),

/***/ 83817:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');

exports.Z = _default;

/***/ }),

/***/ 74419:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarHalf');

exports.Z = _default;

/***/ }),

/***/ 38579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}), 'ArrowForwardIos'));

/***/ }),

/***/ 47817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ID": function() { return /* binding */ searchRecentListings; },
/* harmony export */   "Vm": function() { return /* binding */ searchCaterers; },
/* harmony export */   "qo": function() { return /* binding */ searchRecentCaterers; }
/* harmony export */ });
/* unused harmony exports getCaterer, searchListings, searchMostBooked, searchBestRated, searchCaterersBy */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24955);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _algolia_cache_in_memory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7385);






var algoliaAppId = "NU9B0W8STM";
var algoliaSearchApiKey = "4fbffb589c274485bb9416c80a37d4f6";
if (!algoliaAppId) {
    throw new Error("Missing ENV Variable: Algolia app id");
}
if (!algoliaSearchApiKey) {
    throw new Error("Missing ENV Variable: Algolia search api key");
}
var client = algoliasearch__WEBPACK_IMPORTED_MODULE_0___default()(algoliaAppId, algoliaSearchApiKey, {
    responsesCache: (0,_algolia_cache_in_memory__WEBPACK_IMPORTED_MODULE_1__/* .createInMemoryCache */ .R)(),
    requestsCache: (0,_algolia_cache_in_memory__WEBPACK_IMPORTED_MODULE_1__/* .createInMemoryCache */ .R)({
        serializable: false
    })
});
/*
 * INDEXES
 */ var INDEX_PREFIX = "production";
var catererMarketplaceIndex = createIndex("caterer_marketplace");
var listingsMarketplaceIndex = createIndex("listings_marketplace");
var numberOfOrdersIndex = createIndex("caterer_marketplace_number_of_orders_desc");
var ratingScoreIndex = createIndex("caterer_marketplace_rating_score_desc");
var catererCreatedAtSortedIndex = createIndex("caterer_marketplace_created_at_desc");
var listingsCreatedAtSortedIndex = createIndex("listings_marketplace_created_at_desc");
var getCaterer = function(id) {
    return catererMarketplaceIndex.getObject(id);
};
/*
 * SEARCH FUNCTIONS
 */ var searchRecentCaterers = createSearchHandler(catererCreatedAtSortedIndex);
var searchRecentListings = createSearchHandler(listingsCreatedAtSortedIndex);
var searchCaterers = createSearchHandler(catererMarketplaceIndex);
var searchListings = createSearchHandler(listingsMarketplaceIndex);
var searchMostBooked = createSearchHandler(numberOfOrdersIndex);
var searchBestRated = createSearchHandler(ratingScoreIndex);
var searchCaterersBy = function(_param) {
    var city = _param.city, keywords = _param.keywords, method = _param.method, searchOptions = _object_without_properties(_param, [
        "city",
        "keywords",
        "method"
    ]);
    var fetcher = method === "mostBooked" ? searchMostBooked : searchBestRated;
    var cityFilter = city ? {
        filters: 'cities:"'.concat(city, '"')
    } : {};
    return fetcher(keywords, _object_spread({}, cityFilter, searchOptions));
};
/*
 * UTILS
 */ function createSearchHandler(index) {
    return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var queryString, params, query, hits;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    queryString = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", params = _arguments.length > 1 ? _arguments[1] : void 0;
                    query = Array.isArray(queryString) ? queryString.join(" ") : queryString;
                    return [
                        4,
                        index.search(query, params)
                    ];
                case 1:
                    hits = _state.sent().hits;
                    return [
                        2,
                        hits
                    ];
            }
        });
    });
}
function createIndex(name) {
    return client.initIndex("".concat(INDEX_PREFIX, "_").concat(name));
}


/***/ }),

/***/ 90848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border-radius: 50%;\n    flex-shrink: 0;\n    border: ",
        ";\n    padding: 0;\n    box-sizing: border-box;\n    transition: background-color 0.1s ease-out;\n    width: ",
        ";\n    height: ",
        ";\n\n    cursor: ",
        ";\n\n    &:hover: {\n      background-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Dots = function(param) {
    var count = param.count, activeIndex = param.activeIndex, onClick = param.onClick, _size = param.size, size = _size === void 0 ? "11px" : _size, _color = param.color, color = _color === void 0 ? "#E3E4E4" : _color, border = param.border, _activeColor = param.activeColor, activeColor = _activeColor === void 0 ? "#3C4340" : _activeColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: new Array(count).fill(1).map(function(_, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Dot, {
                as: onClick ? "button" : "div",
                type: "button",
                "aria-label": "select slide: ".concat(index + 1),
                onClick: onClick ? function() {
                    return onClick(index);
                } : undefined,
                $active: activeIndex === index,
                $size: size,
                $color: color,
                $activeColor: activeColor,
                $isButton: !!onClick,
                $border: border
            }, index);
        })
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var Dot = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject2(), function(param) {
    var $active = param.$active, $size = param.$size, $activeColor = param.$activeColor, $color = param.$color, $isButton = param.$isButton, _$border = param.$border, $border = _$border === void 0 ? "none" : _$border;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1(), $active ? $activeColor : $color, $border, $size, $size, $isButton ? "pointer" : "auto", $isButton ? $activeColor : $color);
});
/* harmony default export */ __webpack_exports__["Z"] = (Dots);


/***/ }),

/***/ 53279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ attributeNameForLocale; },
/* harmony export */   "u": function() { return /* binding */ algoliaAttributeNameForLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48403);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0__);


var localeConfig = {
    locales: [
        "en",
        "de"
    ],
    defaultLocale: "de"
};
var algoliaAttributeNameForLocale = function(locale) {
    return function(name) {
        var toLocalizedAlgoliaKey = function(name) {
            var parsedLocale = localeConfig.locales.includes(locale) ? locale : localeConfig.defaultLocale;
            return "".concat(name, "_").concat(parsedLocale);
        };
        if (name.includes(".")) {
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(name.split("."), 2), scope = ref[0], fieldName = ref[1];
            // @ts-expect-error: edge case, hard to type
            return "".concat(scope, ".").concat(toLocalizedAlgoliaKey(fieldName));
        }
        return toLocalizedAlgoliaKey(name);
    };
};
var attributeNameForLocale = function(locale) {
    return function(name) {
        if (!localeConfig.locales.includes(locale)) return "".concat(name).concat(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default()(localeConfig.defaultLocale));
        return "".concat(name).concat(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default()(locale));
    };
};


/***/ }),

/***/ 11162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useCurrencySymbol; }
/* harmony export */ });
/* harmony import */ var shared_hooks_useIsGb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9858);

var useCurrencySymbol = function() {
    var isGb = (0,shared_hooks_useIsGb__WEBPACK_IMPORTED_MODULE_0__/* .useIsGb */ .y)();
    return isGb ? "\xa3" : "€";
};


/***/ }),

/***/ 9858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useIsGb; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var useIsGb = function() {
    var slug = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().query.slug;
    return slug === "catering-london";
};


/***/ }),

/***/ 25734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalizedFieldName; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53279);


function useLocalizedFieldName() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var localizedFieldAlgolia = (0,shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__/* .algoliaAttributeNameForLocale */ .u)(router.locale);
    var localizedAttributeName = (0,shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__/* .attributeNameForLocale */ .q)(router.locale);
    return {
        localizedFieldAlgolia: localizedFieldAlgolia,
        localizedAttributeName: localizedAttributeName
    };
}


/***/ }),

/***/ 98038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ usePagination; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/helpers/array.ts
function chunk(array, length) {
    var chunks = [];
    var i = 0;
    var n = array.length;
    while(i < n){
        chunks.push(array.slice(i, i += length));
    }
    return chunks;
}

;// CONCATENATED MODULE: ./src/shared/hooks/usePagination.ts


var usePagination = function(items, param) {
    var pageSize = param.pageSize, initialPage = param.initialPage, limit = param.limit;
    var ref = (0,react.useState)(initialPage || 0), pageIndex = ref[0], setPageIndex = ref[1];
    var paginatedItems = (0,react.useMemo)(function() {
        return chunk(limit ? items.slice(0, limit) : items, pageSize);
    }, [
        items,
        limit,
        pageSize
    ]);
    var lastPageIndex = paginatedItems.length - 1;
    var next = (0,react.useCallback)(function() {
        return setPageIndex(function(prev) {
            return (prev + 1) % paginatedItems.length;
        });
    }, [
        pageSize
    ]);
    var prev = (0,react.useCallback)(function() {
        return setPageIndex(function(prev) {
            return prev - 1 === -1 ? lastPageIndex : prev - 1;
        });
    }, [
        pageSize
    ]);
    return {
        pages: paginatedItems,
        currentPage: paginatedItems[pageIndex],
        nextPage: paginatedItems[pageIndex + 1],
        prevPage: paginatedItems[pageIndex - 1],
        pageCount: paginatedItems.length,
        pageIndex: pageIndex,
        next: next,
        prev: prev,
        setPageIndex: setPageIndex
    };
};


/***/ }),

/***/ 57813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MPPreviewCards; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var lib_algolia_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47817);
/* harmony import */ var static_pages_marketing_pages_components_TopCaterers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36926);







function MPPreviewCards(param) {
    var _ids = param.ids, ids = _ids === void 0 ? [] : _ids, ctaTitle = param.ctaTitle, ctaLink = param.ctaLink, title = param.title;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), caterers = ref[0], setCaterers = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        function fetchCaterers() {
            return _fetchCaterers.apply(this, arguments);
        }
        function _fetchCaterers() {
            _fetchCaterers = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var filters, hits;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            filters = [];
                            if (ids.length > 0) {
                                filters.push("(".concat(ids.map(function(id) {
                                    return 'slug:"'.concat(id, '"');
                                }).join(" OR "), ")"));
                            }
                            return [
                                4,
                                (0,lib_algolia_client__WEBPACK_IMPORTED_MODULE_3__/* .searchCaterers */ .Vm)("", {
                                    filters: filters.toString(),
                                    hitsPerPage: 100
                                })
                            ];
                        case 1:
                            hits = _state.sent();
                            setCaterers(hits);
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchCaterers.apply(this, arguments);
        }
        fetchCaterers();
    }, [
        ids
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Box, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(static_pages_marketing_pages_components_TopCaterers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            cta: ctaTitle,
            topCaterers: caterers,
            title: title,
            ctaLink: ctaLink
        })
    });
}


/***/ }),

/***/ 36926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TopCaterers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(38579);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/shared/components/Dots.tsx
var Dots = __webpack_require__(90848);
// EXTERNAL MODULE: ./src/shared/hooks/usePagination.ts + 1 modules
var usePagination = __webpack_require__(98038);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/TopCaterersCard.js + 2 modules
var TopCaterersCard = __webpack_require__(97010);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/helpers.ts
var helpers = __webpack_require__(10904);
// EXTERNAL MODULE: ./src/system/components/Button/DarkButton.js
var DarkButton = __webpack_require__(93925);
;// CONCATENATED MODULE: ./src/system/components/Button/TransparentButton.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n  color: #3c4340;\n\n  :hover {\n    background-color: rgba(0, 0, 0, 0.07);\n  }\n\n  :active {\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TransparentButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject());
/* harmony default export */ var Button_TransparentButton = (TransparentButton);

// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/index.js

function TopCaterers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 36px;\n  }\n"
    ]);
    TopCaterers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 55px;\n  width: 55px;\n  border-radius: 100px;\n  padding: 0;\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: scaleX(-1);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  bottom: 0;\n  left: ",
        ";\n  right: ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n\n  scroll-snap-type: x mandatory;\n  margin-right: auto;\n  position: relative;\n  width: fit-content;\n  max-width: 100%;\n  overflow: auto;\n  display: flex;\n  gap: ",
        "px;\n  padding: ",
        ";\n  padding-bottom: ",
        "px;\n\n  @media (hover: hover) {\n    // No scrollbar on non-touch devices\n    overflow: hidden;\n  }\n\n  ",
        " {\n    padding-bottom: ",
        "px;\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    overflow: visible; // So the slide buttons will be visible\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  margin-left: auto;\n  position: relative;\n  width: fit-content;\n  scroll-snap-align: center;\n\n  scroll-behavior: smooth;\n  max-width: 100%;\n  margin-right: auto;\n  display: flex;\n\n  gap: ",
        "px;\n\n  align-items: stretch;\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

















var PAGINATION = {
    XS: {
        itemsPerPage: 1,
        maxPages: 6
    },
    SM: {
        itemsPerPage: 2,
        maxPages: 6
    },
    MD: {
        itemsPerPage: 3,
        maxPages: 4
    },
    LG: {
        itemsPerPage: 4,
        maxPages: 3
    }
};
var usePaginationSetup = function() {
    var isSM = (0,useBreakpoints/* useBreakpointUp */._)("sm");
    var isMD = (0,useBreakpoints/* useBreakpointUp */._)("md");
    var isLG = (0,useBreakpoints/* useBreakpointUp */._)("lg");
    var paginationSetup = PAGINATION.XS;
    if (isSM) {
        paginationSetup = PAGINATION.SM;
    }
    if (isMD) {
        paginationSetup = PAGINATION.MD;
    }
    if (isLG) {
        paginationSetup = PAGINATION.LG;
    }
    return paginationSetup;
};
function TopCaterers(param) {
    var _topCaterers = param.topCaterers, topCaterers = _topCaterers === void 0 ? [] : _topCaterers, title = param.title, city = param.city, cta = param.cta, cateringCategories = param.cateringCategories, _ctaLink = param.ctaLink, ctaLink = _ctaLink === void 0 ? undefined : _ctaLink;
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref1 = (0,react.useState)(false), isScrolling = ref1[0], setScrolling = ref1[1];
    var stopScrollingStateTimeoutRef = (0,react.useRef)(null);
    var paginationSetup = usePaginationSetup();
    var isDesktop = (0,useBreakpoints/* useBreakpointUp */._)("lg");
    var router = (0,next_router.useRouter)();
    var cardPageItemsRef = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        pagination.setPageIndex(0);
    }, [
        paginationSetup
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (stopScrollingStateTimeoutRef.current) {
                clearTimeout(stopScrollingStateTimeoutRef.current);
            }
        };
    }, []);
    var handleDotClick = function(index) {
        if (stopScrollingStateTimeoutRef.current) {
            clearTimeout(stopScrollingStateTimeoutRef.current);
        }
        setScrolling(true);
        pagination.setPageIndex(index);
        scrollPageIntoView(index);
        stopScrollingStateTimeoutRef.current = setTimeout(function() {
            return setScrolling(false);
        }, 800);
    };
    var pagination = (0,usePagination/* usePagination */.h)(topCaterers, {
        pageSize: paginationSetup.itemsPerPage,
        limit: paginationSetup.itemsPerPage * paginationSetup.maxPages
    });
    var ref2 = (0,react_intersection_observer_m/* useInView */.YD)(), isSectionInView = ref2.inView, sectionRef = ref2.ref;
    var scrollPageIntoView = function(pageIndex) {
        var ref;
        var pageElement = cardPageItemsRef === null || cardPageItemsRef === void 0 ? void 0 : (ref = cardPageItemsRef.current) === null || ref === void 0 ? void 0 : ref[pageIndex];
        if (isSectionInView && pageElement) {
            pageElement.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    if (topCaterers.length < 3) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    py: 6,
                    sm: {
                        py: 4
                    },
                    xs: {
                        py: 2
                    },
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                        component: "h2",
                        gutterBottom: true,
                        children: title || "Top Caterers"
                    })
                })
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsGrid, {
                        children: (ref = pagination.currentPage) === null || ref === void 0 ? void 0 : ref.map(function(caterer) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCaterersCard/* default */.Z, {
                                caterer: caterer,
                                city: city
                            }, caterer.objectID);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButtonWrapper, {
                        left: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
                            onClick: pagination.prev,
                            disabled: !pagination.prevPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                mr: 0.4,
                                mt: 0.4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButtonWrapper, {
                        right: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
                            onClick: function() {
                                return handleDotClick(pagination.pageIndex + 1);
                            },
                            disabled: !pagination.nextPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                ml: 0.6,
                                mt: 0.4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {})
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsWrapper, {
                ref: sectionRef,
                children: pagination.pages.map(function(page, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                        threshold: 1,
                        onChange: function(inView) {
                            if (inView && !isScrolling) {
                                pagination.setPageIndex(index);
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsGrid, {
                            ref: function(element) {
                                cardPageItemsRef.current[index] = element;
                            },
                            children: page.length ? page.map(function(caterer) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCaterersCard/* default */.Z, {
                                    caterer: caterer,
                                    city: city
                                }, caterer.objectID);
                            }) : null
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                textAlign: "center",
                mt: {
                    xs: 2,
                    md: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                    count: pagination.pageCount,
                    activeIndex: pagination.pageIndex,
                    onClick: handleDotClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    pt: {
                        xs: 4,
                        md: 6
                    },
                    pb: 4,
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkButton/* default */.Z, {
                        size: "lg",
                        rounded: true,
                        as: "a",
                        target: "_blank",
                        href: ctaLink || (0,helpers/* buildFunnelUrl */.$e)({
                            city: city,
                            cateringCategories: cateringCategories,
                            router: router
                        }),
                        children: cta ? cta : t("catererCards.cta")
                    })
                })
            })
        ]
    });
}
var TitleTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(TopCaterers_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var SlideButton = (0,styled_components_browser_esm["default"])(Button_TransparentButton)(_templateObject1());
var ArrowBackIos = (0,styled_components_browser_esm["default"])(ArrowForwardIos/* default */.Z)(_templateObject2());
var SlideButtonWrapper = styled_components_browser_esm["default"].div(_templateObject3(), function(param) {
    var left = param.left;
    return left ? "-60px" : "none";
}, function(param) {
    var right = param.right;
    return right ? "-60px" : "none";
});
var CardsWrapper = styled_components_browser_esm["default"].div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var CardsGrid = styled_components_browser_esm["default"].div(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});


/***/ }),

/***/ 93925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95197);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: 1px solid #3c4340;\n          color: #3c4340;\n          background-color: transparent;\n          :hover {\n            background-color: rgba(0, 0, 0, 0.07);\n            border-color: inherit;\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background-color: #3c4340;\n          :hover {\n            background-color: #242927;\n          }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  line-height: 1;\n  min-height: 42px;\n  display: inline-grid;\n  place-content: center;\n  white-space: normal;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var DarkButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_1__.Button)(_templateObject2(), function(param) {
    var outline = param.outline;
    return outline ? (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1());
});
/* harmony default export */ __webpack_exports__["Z"] = (DarkButton);


/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; },
/* harmony export */   "df": function() { return /* binding */ InView; }
/* harmony export */ });
/* unused harmony exports default, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ })

}]);